import { useMemo } from "react";
import shallow from "zustand/shallow";
import { useShelvingStore } from "../../../../../store";
import { SectionNomenclature, SideTypeWithoutTop } from "../../../../../store/types/store";

function useSectionsBySide(): SectionNomenclature[] {
    const { shelving } = useShelvingStore(
        (state) => ({
            shelving: state.shelving,
        }),
        shallow
    );

    return useMemo(
        () => [
            ...shelving.left.sections.map((section) => ({ ...section, side: "left" as SideTypeWithoutTop })),
            ...shelving.front.sections.map((section) => ({ ...section, side: "front" as SideTypeWithoutTop })),
            ...shelving.right.sections.map((section) => ({ ...section, side: "right" as SideTypeWithoutTop })),
            ...shelving.back.sections.map((section) => ({ ...section, side: "back" as SideTypeWithoutTop })),
        ],
        [shelving.left.sections, shelving.front.sections, shelving.right.sections, shelving.back.sections]
    );
}

export default useSectionsBySide;
